/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-07-18 12:25:48
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-07-26 09:31:14
 */
import HomeData from "../views/home/home-screen/home-screen.vue";
const home = () => import("@/views/home/home/home.vue");
const routerList = [
    {
        path: "/home/index",
        name: "主页面",
        component: home,
        children: [
            {
                path: "/home/index/home-data",
                name: "主页大屏",
                component: HomeData,
                meta: {
                    full: true,
                },
            },
            {
                path: "/home/index/home-pile",
                name: "站下桩列表",
                component: () => import("@/views/home/home/children/home-pile/home-pile.vue"),
                meta: {
                    nameKey: "homePileSta",
                },
            },
            {
                path: "/home/index/home-pile/pile",
                name: "桩详情",
                component: () => import("@/views/home/home/children/home-pile-detail/home-pile-detail.vue"),
                meta: {
                    nameKey: "homePileStaPile",
                },
            },
        ],
    },
];
export default routerList;
